import NewTaskForm, { useNewTaskFormData } from 'components/NewTaskForm';
import React, { useEffect, useState } from 'react';
import { formatType, getPath } from 'utils/entity.utils';

import { Dialog } from '@acheloisbiosoftware/absui.core';
import { ENTITY_TASK } from 'constants/schemas';
import PropTypes from 'prop-types';
import { getGenericId } from 'utils/generic.utils';
import { taskActions } from 'store/entity';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function NewTaskDialog(props) {
  const { open, onClose, initState } = props;
  const {
    formData,
    valid,
    resetFormData,
    updateFormData,
  } = useNewTaskFormData(initState);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) resetFormData();
  }, [open, resetFormData]);

  const _onClose = () => {
    resetFormData();
    onClose();
  };

  const onConfirm = () => {
    setLoading(true);
    dispatch(taskActions.createTask(formData))
      .unwrap()
      .then((res) => {
        _onClose();
        navigate(getPath(getGenericId(res.result, ENTITY_TASK)));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog
      title={`New ${formatType(ENTITY_TASK, { template: formData?.is_template })}`}
      open={open}
      onClose={_onClose}
      confirmButtonText='Create'
      disableCloseOnConfirm
      onConfirm={onConfirm}
      loading={loading}
      confirmDisabled={!valid}
      maxWidth='md'
      fullWidth
    >
      <NewTaskForm
        formData={formData}
        updateFormData={updateFormData}
      />
    </Dialog>
  );
}

NewTaskDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  initState: PropTypes.object,
};

export default NewTaskDialog;
